import React from "react";
import cartImg from "@/assets/img/cartIMG.svg";
import Button from "../ui/Button";
import { ShineBorder } from "@/components/ui/shine-border";
import { BoxReveal } from "@/components/ui/box-reveal";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  merchantId: string;
  merchantName: string;
  promotionText?: string;
}

const AdModal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  merchantName,
  promotionText,
}) => {
  if (!isOpen) return null;

  // Function to render promotion text with price tag icons
  const renderPromotionText = (text: string) => {
    const promotions = text.split("\n").filter((line) => line.trim());

    return promotions.map((promotion, index) => (
      <div key={index} className="flex items-start space-x-3">
        <p className="text-lg">{promotion}</p>
      </div>
    ));
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-50" onClick={onClose} />

      {/* Modal Content */}
      <div className="relative bg-white rounded-3xl shadow-lg w-[90%] max-w-md p-6 z-50 mx-4 overflow-hidden">
        <ShineBorder shineColor="#D32626" duration={10} borderWidth={2} />
        <BoxReveal>
          <h2 className="text-2xl font-bold text-center mb-4">
            Welcome to {merchantName}
          </h2>
        </BoxReveal>
        <BoxReveal>
          {promotionText && (
            <div className="space-y-4 mb-6">
              {renderPromotionText(promotionText)}
            </div>
          )}
        </BoxReveal>

        <BoxReveal>
          <div className="flex justify-center mb-6">
            <img src={cartImg} alt="Shopping Cart" className="w-32 h-32" />
          </div>
        </BoxReveal>

        <div className="flex justify-center">
          <Button
            variant="primary"
            text="Get Started"
            className="w-[90%] h-[2.5rem] rounded-[8px] text-[18px] font-[700] flex items-center justify-center"
            onClick={onClose}
          />
        </div>
      </div>
    </div>
  );
};

export default AdModal;
